import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs/Subject";

import "rxjs/add/operator/takeUntil";

@Component({
  selector: "oneiam-error",
  templateUrl: "./oneiam-error.component.html",
  styleUrls: ["./oneiam-error.component.scss"]
})
export class OneiamErrorComponent implements OnInit, OnDestroy {
  public loginUrl: string;
  private unsubscribe = new Subject<void>();

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams
      .takeUntil(this.unsubscribe)
      .subscribe(params => {
        if (params["from"]) {
          this.loginUrl = `/oneiam/login?next=${encodeURIComponent(params["from"])}`;
        } else {
          this.loginUrl = "/oneiam/login";
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/errors/oneiam-error/oneiam-error.component.ts